const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM2EyIDIgMCAwIDEgMiAydjE0YTIgMiAwIDAgMS0yIDJIM2EyIDIgMCAwIDEtMi0yVjVhMiAyIDAgMCAxIDItMmgxOHptMCA2LjYxOGwtOSA0LjUtOS00LjVWMTloMThWOS42MTh6TTIxIDVIM3YyLjM4Mmw5IDQuNSA5LTQuNVY1eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=e_mail-f650f4e1.mjs.map
